import { Component, OnDestroy } from '@angular/core';
import { ICellRendererComp } from 'ag-grid-community';
import { ActionItem, ActionItemRendererParams } from '../interfaces/ag-grid-cell-renderer.interface';

export interface ActionMenuCellRendererParams extends ActionItemRendererParams {
  backgroundColor: string;
}

@Component({
  selector: 'app-ag-action-menu-cell-renderer',
  templateUrl: './ag-action-menu-cell-renderer.component.html',
  styleUrl: './ag-action-menu-cell-renderer.component.scss',
  standalone: false
})
export class AgActionMenuCellRendererComponent implements OnDestroy, ICellRendererComp {
  rowData: any;
  menuItems: ActionItem[] = [];

  protected params: ActionMenuCellRendererParams;

  eGui: HTMLDivElement;

  agInit(params: ActionMenuCellRendererParams): void {
    this.params = params;
    this.rowData = params.data as any;
    this.menuItems = params.getActionItems ? params.getActionItems(this.params) : [];
  }

  refresh(params: ActionMenuCellRendererParams): boolean {
    this.params = params;
    this.rowData = params.data as any;
    this.menuItems = params.getActionItems ? params.getActionItems(this.params) : [];
    return true;
  }

  onMenuItemClick(item: ActionItem): void {
    item.callback(this.rowData, this.params, item);
  }

  getGui() {
    return this.eGui;
  }

  ngOnDestroy(): void {}
}
